import React, { useState, useEffect } from 'react';
import { ListSubheader, InputLabel, Select, FormControl, MenuItem } from '@mui/material';

export default function GroupSelect(data: any) {
    const [selectedPlan, setSelectedPlan] = useState({});

    const preparedData: { id: any; name: any; plans: any[] }[] = [];

    data.items &&
        data.items.forEach((item: any) => {
            const cat = preparedData.find((currentItem) => currentItem.name === item.category);
            if (cat) {
                cat.plans.push(item);
            } else {
                preparedData.push({
                    id: item.category,
                    name: item.category,
                    plans: [item],
                });
            }
        });

    const handleChange = (event: any) => {
        data.onChange(event);
        setSelectedPlan(event.target.value);
    };

    const renderSelectGroup = (product: any) => {
        const items = product.plans.map((p: any) => {
            return (
                <MenuItem key={p.id} value={p.id} style={{ whiteSpace: 'normal' }}>
                    {p.text}
                </MenuItem>
            );
        });
        return [
            <ListSubheader
                key={product.id}
                sx={{
                    bgcolor: '#c21b17',
                    color: '#fff',
                    lineHeight: '30px',
                }}
            >
                {product.name}
            </ListSubheader>,
            items,
        ];
    };

    useEffect(() => {
        setSelectedPlan(data.value);
    }, [selectedPlan]);

    return (
        <>
            <FormControl error={data.error} required={data.required}>
                <InputLabel>{data.label}</InputLabel>
                <Select
                    value={selectedPlan || ''}
                    name="cause"
                    onChange={handleChange}
                    label={data.label}
                    MenuProps={{
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'left',
                        },
                        transformOrigin: {
                            vertical: 'top',
                            horizontal: 'left',
                        },
                        // @ts-ignore
                        getcontentanchorel: null,
                    }}
                >
                    {preparedData?.map((p: any) => renderSelectGroup(p))}
                </Select>
            </FormControl>
        </>
    );
}
